// Mock data for VGLM clone

export const services = [
  {
    title: 'Lawn Mowing',
    image:
      'https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/nXvGBSdAJRfNxUNGToP1/media/69ff3b76a7b9e0385a2a24de.png',
    desc: 'Professional lawn mowing services that keep your property looking neat, healthy, and well maintained with reliable care and attention to detail.',
  },
  {
    title: 'Gardening',
    image:
      'https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/nXvGBSdAJRfNxUNGToP1/media/69ff3a657285562721eeab0a.png',
    desc: 'Reliable gardening services designed to keep outdoor spaces clean, tidy, and healthy with regular care and attention to detail.',
  },
  {
    title: 'Weed Control',
    image:
      'https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/nXvGBSdAJRfNxUNGToP1/media/69ff3a657285562721eeab09.png',
    desc: 'Professional weed control services that target invasive growth in lawns, garden beds, paths, and driveways, keeping your property tidy, healthy, and well maintained year-round.',
  },
  {
    title: 'Acreage Mowing',
    image:
      'https://customer-assets-eiarnc6j.emergentagent.net/job_vglm-preview/artifacts/8fhw82ns_782730178_122190849452866495_3209281853443652883_n.jpg',
    desc: 'Ride-on mowing and slashing for large blocks, lifestyle properties, semi-rural acreage, and long driveways, set up for big jobs with the right gear.',
  },
];

export const additionalServices = [
  'Gutter Cleaning',
  'Green Waste Removal',
  'Tree Trimming',
  'Softscapes',
  'Turf Supply & Installation',
];

export const aboutImage =
  'https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/nXvGBSdAJRfNxUNGToP1/media/69ff3a65bc1f77cc352d032f.png';

export const gallery = [
  'https://images.leadconnectorhq.com/image/f_webp/q_80/r_800/u_https://assets.cdn.filesafe.space/nXvGBSdAJRfNxUNGToP1/media/69ff3bda054a6c3d90578523.png',
  'https://images.leadconnectorhq.com/image/f_webp/q_80/r_800/u_https://assets.cdn.filesafe.space/nXvGBSdAJRfNxUNGToP1/media/69ff3bdaa3dd25aa2acc959c.png',
  'https://images.leadconnectorhq.com/image/f_webp/q_80/r_800/u_https://assets.cdn.filesafe.space/nXvGBSdAJRfNxUNGToP1/media/69ff3bdaa7b9e0385a2a36ca.png',
  'https://images.leadconnectorhq.com/image/f_webp/q_80/r_800/u_https://assets.cdn.filesafe.space/nXvGBSdAJRfNxUNGToP1/media/69ff3bdabc1f77cc352d439e.png',
  'https://images.leadconnectorhq.com/image/f_webp/q_80/r_800/u_https://assets.cdn.filesafe.space/nXvGBSdAJRfNxUNGToP1/media/69ff3bdaa7b9e0385a2a36cc.png',
  'https://images.leadconnectorhq.com/image/f_webp/q_80/r_800/u_https://assets.cdn.filesafe.space/nXvGBSdAJRfNxUNGToP1/media/69ff3bdaa7b9e0385a2a36cb.png',
  'https://images.leadconnectorhq.com/image/f_webp/q_80/r_800/u_https://assets.cdn.filesafe.space/nXvGBSdAJRfNxUNGToP1/media/69ff3bdaa7b9e0385a2a36c9.png',
  'https://images.leadconnectorhq.com/image/f_webp/q_80/r_800/u_https://assets.cdn.filesafe.space/nXvGBSdAJRfNxUNGToP1/media/69ff3bdabc1f77cc352d43a1.png',
  'https://images.leadconnectorhq.com/image/f_webp/q_80/r_800/u_https://assets.cdn.filesafe.space/nXvGBSdAJRfNxUNGToP1/media/69ff3bdabc1f77cc352d439f.png',
  'https://customer-assets-eiarnc6j.emergentagent.net/job_vglm-preview/artifacts/cgaxm46q_download.png',
  'https://customer-assets-eiarnc6j.emergentagent.net/job_vglm-preview/artifacts/6s233r3q_Untitled%20design%20%282%29.webp',
  'https://customer-assets-eiarnc6j.emergentagent.net/job_vglm-preview/artifacts/mn6iekhl_Untitled%20design%20%283%29.webp',
];

export const testimonials = [
  {
    id: 'review-isabelle-pudney',
    name: 'Isabelle Pudney',
    text: 'Always very happy with results and very reasonably priced as well!',
    rating: 5,
    datePublished: '2024-08-15',
    dateDisplay: '2024',
  },
  {
    id: 'review-ronn-rks',
    name: 'ronn rks',
    text: "Adam has been taking care of my lawns and gardens for a while and I cannot recommend him highly enough. In all this time, his work has been absolutely flawless. He goes above and beyond in ways that truly matter. If I'm not around, he always sends photos and videos so I can see the great job he's done. When I'm working from home, he is incredibly thoughtful and ensures he doesn't disturb my work. From immaculate front and backyard maintenance to precision tree trimming, his attention to detail is unmatched. On top of that, he is always happy to share helpful maintenance tips to keep the garden looking its best. Reliable, professional, and incredibly helpful. Adam is the best in the business!",
    rating: 5,
    datePublished: '2024-11-20',
    dateDisplay: '2024',
  },
  {
    id: 'review-tina-bouch',
    name: 'Tina Bouch',
    text: "Adam was so efficient, NO MORE WEEDS I can't believe it. Would definitely recommend Adam he does what he says and leaves the gardens beautiful and fresh.",
    rating: 5,
    datePublished: '2025-01-10',
    dateDisplay: '2025',
  },
  {
    id: 'review-belinda-gray',
    name: 'Belinda Gray',
    text: 'Extremely happy, his team did an amazing job! Highly recommend.',
    rating: 5,
    dateDisplay: 'Google Review',
  },
  {
    id: 'review-grazyna-garbowski',
    name: 'Grazyna Garbowski',
    text: 'Outstanding service provided by Adam, who has continuously proven high level service with mowing, other garden duties and kind suggestions. Greatly appreciate his ongoing care, patience, time and work. Sincere thanks. Grace.G',
    rating: 5,
    datePublished: '2026-05-24',
    dateDisplay: '9 weeks ago',
  },
  {
    id: 'review-jillian-pyke',
    name: 'Jillian Pyke',
    text: 'The way you looked after my lawns was great!!',
    rating: 5,
    dateDisplay: 'Google Review',
  },
  {
    id: 'review-lynee-mathison',
    name: 'Lynee Mathison',
    text: 'Adam has looked after our lawns for awhile. He has been great. Does a fantastic job! Thank you Adam you are awesome! Highly recommend!',
    rating: 5,
    datePublished: '2026-05-24',
    dateDisplay: '9 weeks ago',
  },
  {
    id: 'review-molly-b',
    name: 'Molly B',
    text: 'Adam has always been amazing when accomodating doing my lawns for me! Super great service that I continue to use!',
    rating: 5,
    datePublished: '2026-05-25',
    dateDisplay: '9 weeks ago',
  },
  {
    id: 'review-heather',
    name: 'Heather',
    text: 'Punctual, skilled, and friendly every visit, a long-time client with no plans to switch gardeners!',
    rating: 5,
    dateDisplay: 'Google Review',
  },
  {
    id: 'review-ngaire',
    name: 'Ngaire',
    text: 'Extremely reliable, proactive, and always willing to check in and advise. Highly recommend for short-term or ongoing garden care in Ballarat.',
    rating: 5,
    dateDisplay: 'Google Review',
  },
  {
    id: 'review-jose',
    name: 'Jose',
    text: 'Needed my rental property presentable fast for an inspection and Adam turned it around in days. Very impressed with his work, price and just a great attitude!',
    rating: 5,
    dateDisplay: 'Google Review',
  },
];

export const faqs = [
  {
    id: 'faq-cost',
    q: 'How much does lawn mowing cost?',
    a: 'Every property is different, so pricing depends on the size of your lawn, how often you want it mowed, and any extras like edging, weeding or green waste removal. Most regular residential mows are very affordable, and we always provide a free, no obligation quote up front so you know exactly what to expect, with no surprises.',
  },
  {
    id: 'faq-recurring',
    q: 'Do you offer one-off visits or regular recurring maintenance?',
    a: 'Both. We take care of one-off tidy ups, which are great for rentals, inspections or sales, as well as weekly, fortnightly and monthly recurring maintenance. Most clients choose a regular schedule so their lawns and gardens always look their best without having to think about it.',
  },
  {
    id: 'faq-areas',
    q: 'Which areas do you service?',
    a: 'We provide residential lawn and garden maintenance across a wide range of local suburbs and nearby towns, and we also offer commercial grounds maintenance further afield. If you are not sure whether we reach your street, just ask and we will be happy to let you know.',
  },
  {
    id: 'faq-insured',
    q: 'Are you fully insured, police checked and Working With Children checked?',
    a: 'Yes. Vic Garden and Lawn Maintenance is fully insured with public liability cover, and we hold a current Police Check and Working With Children Check. We are ABN registered, so you can feel completely confident having us on your property.',
  },
  {
    id: 'faq-ndis-dva',
    q: 'Do you accept NDIS and DVA clients?',
    a: 'Yes. We are an NDIS registered provider and a DVA approved provider, and we regularly help participants and veterans keep their lawns and gardens safe, tidy and well maintained. Get in touch and we will walk you through how it works.',
  },
  {
    id: 'faq-start-home',
    q: 'How soon can you start, and do I need to be home during the visit?',
    a: 'We can usually get you booked in quickly after your quote is confirmed. You do not need to be home for us to work, as many clients leave us to it and simply come back to a freshly maintained property. If you prefer, we can also send photos once the job is done.',
  },
  {
    id: 'faq-green-waste',
    q: 'Do you remove green waste and grass clippings?',
    a: 'Yes. We can clean up and remove grass clippings, pruning offcuts and general green waste as part of the job so you are left with a tidy, finished result. Just let us know when you request your quote and we will include it.',
  },
  {
    id: 'faq-acreage',
    q: 'Do you offer acreage and ride on mowing?',
    a: 'Absolutely. We are set up with the right gear for large blocks, lifestyle properties, semi rural acreage and long driveways, including ride on mowing and slashing. No job is too big, so get in touch for a tailored quote.',
  },
  {
    id: 'faq-services',
    q: 'What types of services do you offer?',
    a: 'Vic Garden and Lawn Maintenance offers professional Lawn Mowing, Gardening, Weed Control and Acreage Mowing, plus extras like gutter cleaning, green waste removal, tree trimming, softscapes, and turf supply and installation, all delivered with quality workmanship and reliable service.',
  },
  {
    id: 'faq-fee',
    q: 'Is there a fee for a consultation or quote?',
    a: 'No. All our quotes are completely free and come with no obligation. We make the process simple and stress free, with honest pricing and friendly service from the first phone call.',
  },
  {
    id: 'faq-references',
    q: 'Can you provide references from past clients?',
    a: 'Yes. We have many happy clients who are glad to vouch for our reliable, high quality work, and you can read our genuine 5 star Google reviews right here on the site.',
  },
  {
    id: 'faq-get-quote',
    q: 'How do I get a free quote?',
    a: 'Easy. Call us on 0450 536 106, or fill in the quick quote form on this page with a few details about your property, and you can even attach photos. We will get back to you promptly with a free, no obligation quote.',
  },
];

export const business = {
  name: 'Vic Garden and Lawn Maintenance',
  phone: '0450 536 106',
  email: 'admin@vglm.com.au',
  address: 'Ballarat, Victoria, Australia',
  googleRating: 5.0,
  googleReviewCount: 15,
  googleUrl: 'https://maps.google.com/?cid=13208652711877932519',
  hours: [
    ['Sun', 'Closed'],
    ['Mon', '9:00am - 5:00pm'],
    ['Tue', '9:00am - 5:00pm'],
    ['Wed', '9:00am - 5:00pm'],
    ['Thu', '9:00am - 5:00pm'],
    ['Fri', '9:00am - 5:00pm'],
    ['Sat', 'Closed'],
  ],
  socials: {
    instagram: 'https://www.instagram.com/vicgardenandlawnmaintenance/',
    facebook: 'https://www.facebook.com/vicgardenandlawnmaintenance',
    google: 'https://share.google/82eUspENJGdyF5ZFc',
  },
};

export const logoUrl = '/vglm-logo.png';

export const serviceAreas = [
  'Ballarat', 'Ballarat North', 'Lucas', 'Alfredton', 'Winter Valley', 'Lake Gardens',
  'Ballarat East', 'Brown Hill', 'Black Hill', 'Sebastopol', 'Redan', 'Golden Point',
  'Mount Helen', 'Delacombe',
];
